<template>
  <div
    ref="bar"
    class="verify-account-alert"
  >
    <div
      v-if="showAlert"
      class="d-block d-md-flex justify-content-between align-items-center"
    >
      <div>
        <div
          class="email-verification-message "
          v-html="$t('users.email-verification-message')"
        />
      </div>
      <div class="d-flex align-items-center mt-1 mt-md-0 justify-content-center">
        <template v-for="provider in providers">
          <b-button
            v-if="!emailProvider || emailProvider === provider.name"
            :key="provider.name"
            size="lg"
            :disabled="loading"
            class="email-provider-btn"
            :class="`${provider.name}-provider-btn`"
            variant="outline-light"
            :href="provider.link"
            target="_blank"
          >
            <img
              :src="provider.logo"
              :alt="provider.name"
              height="17.2"
            >
            {{ provider.name }}
          </b-button>
        </template>
        <b-button
          size="lg"
          :disabled="loading"
          :variant="'light'"
          @click="resend"
        >
          <b-spinner
            v-if="loading"
            small
          />
          <span v-else>
            {{ $t('users.resend-email') }}
          </span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BButton, BSpinner } from 'bootstrap-vue'
import debounce from 'lodash/debounce'
import UserApi from '@/API/user-api'

export default {
  name: 'VerifyAccountAlert',
  components: { BButton, BSpinner },
  data() {
    return {
      loading: false,
      providers: [
        /* eslint-disable global-require */
        { name: 'yahoo', link: 'https://mail.yahoo.com/', logo: require('@/assets/images/icons/email/yahoo.svg') },
        { name: 'hotmail', link: 'https://outlook.live.com/mail/', logo: require('@/assets/images/icons/email/outlook.svg') },
        { name: 'gmail', link: 'https://mail.google.com/mail/', logo: require('@/assets/images/icons/email/gmail.svg') },
        /* eslint-enable global-require */
      ],
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      windowWidth: 'app/windowWidth',
    }),
    isVerified() {
      return this.user?.verified
    },
    showAlert() {
      return !this.isVerified
    },
    emailProvider() {
      const yahooRegex = new RegExp(/^[^@]+@(yahoo|ymail|rocketmail)\.(com|in|co\.uk)$/i)
      const gmailRegex = new RegExp(/^[a-z0-9](\.?[a-z0-9]){5,}@g(oogle)?mail\.com$/)
      const hotmailRegex = new RegExp(/(.*)@(live|hotmail)\.(.*)/)

      const email = (this.user.email || '').toLowerCase()
      if (yahooRegex.test(email)) return 'yahoo'
      if (gmailRegex.test(email)) return 'gmail'
      if (hotmailRegex.test(email)) return 'hotmail'
      return null
    },
  },
  watch: {
    showAlert() {
      this.$nextTick(() => this.$emit('update:height', this.$refs.bar.clientHeight))
    },
    windowWidth() {
      if (this.showAlert) {
        this.debounceEmitContainerHeight()
      }
    },
  },
  mounted() {
    this.$nextTick(() => this.$emit('update:height', this.$refs.bar.clientHeight))
  },
  methods: {
    debounceEmitContainerHeight: debounce(function () {
      this.$emit('update:height', this.$refs.bar.clientHeight)
    }, 250),
    resend() {
      this.loading = true
      UserApi.resendVerification()
        .then(() => this.$notifySuccess(`${this.$t('users.sent-successfully')}, ${this.$t('users.check-email')}`))
        .catch(err => this.$notifyError(err))
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style lang="scss">
.verify-account-alert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 12;

  & > div {
    margin-bottom: 2px;
    background: #000000;
    color: #ffffff;
    padding: 17.5px 28.5px;

    .btn-link {
      color: var(--secondary) !important;
      font-weight: 600!important;
      font-size: 14px!important;
    }
  }

  .btn {
    padding: 11.5px 13.5px!important;
    font-size: 12px!important;
    line-height: 1.25!important;
  }

  .email-verification-message {
    font-size: 13px;
    font-weight: 500;
    line-height: 1.54;
    color: #fff;
    max-width: 338px;

    b {
      font-weight: 800!important;
    }
  }

  .email-provider-btn {
    margin-right: 10px;
    font-size: 14px;
    line-height: 1.29;
    text-align: left;
    color: #fff;
    text-transform: capitalize;
    font-family: 'Montserrat', Helvetica, Arial, serif;
    padding: 10px 15px!important;
    border-radius: 6px!important;
    border: solid 1px rgba(215, 214, 221, 0.5)!important;
    height: 40px;

    &.hotmail-provider-btn {
      padding: 9.251px 15px!important;

      img {
        height: 19px!important;
      }
    }
  }
}
</style>
